import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MaintenanceService } from '../services/maintenance.service';
import { TrackingService } from '@schueco/angular-tracking';
import { API_DATA } from '@frontend/util-api-data';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  private maintenanceService = inject(MaintenanceService);
  private trackingService = inject(TrackingService);
  private apiData = inject(API_DATA);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(() => {
        if (req.url.startsWith(this.apiData.apiURL)) {
          this.maintenanceService.setConnectionProblem(false);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const isPimcoreError = error.url?.startsWith(this.apiData.apiURL);

        if (isPimcoreError) {
          if (error.status === 503) {
            this.maintenanceService.setServiceUnavailable(true);
            this.trackingService.trackError(
              `${error.status}: Service Unavailable`,
              error.message || `HTTP ${error.status} error`,
            );
          } else if (error.status === 0) {
            this.maintenanceService.setConnectionProblem(true);
          }
        }

        return throwError(() => error);
      }),
    );
  }
}
